// extracted by mini-css-extract-plugin
export var modal = "_ud-0";
export var table = "_ud-1";